export default "__VITE_ASSET__6c32c1f5__"